import Vue from "vue";

export class Street {
    static create() {
        return {
            cidade: null,
            bairro: null,
            numero: null,
            complemento: null,
            endereco: null,
            estado: null
        };
    }

    static bairros(cidade) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get(
                    "https://cep.centeralarm.com.br/bairros/by-cidade/" + cidade
                )
                .then(res => resolve(res.data), err => reject(err));
        });
    }
}
